module.exports = " <div class=message v-scroll-bottom=session.messages _v-b412eea0=\"\"> <ul v-if=session _v-b412eea0=\"\"> <li v-for=\"item in session.messages\" _v-b412eea0=\"\"> <p class=time _v-b412eea0=\"\"> <span _v-b412eea0=\"\">{{ item.date | time }}</span> </p> <div class=main :class=\"{ self: item.self }\" _v-b412eea0=\"\"> <img class=avatar width=30 height=30 :src=\"item.self ? user.img : session.user.img\" _v-b412eea0=\"\"> <div class=text _v-b412eea0=\"\">{{ item.content }}</div> </div> </li> </ul> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-b412eea0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/message.vue
 ** module id = 326
 ** module chunks = 0
 **/